
export const empresas = {
  hero: {
    title: 'Wealth Engineering for Companies',
    subtitle: 'Technical structuring for corporate asset acquisition, headquarters ownership and expansion via regulated consortiums. Governance, clarity and method applied to corporate wealth.',
    cta_primary: 'Request Corporate Assessment',
    cta_secondary: 'Talk to Specialist'
  },
  applications: {
    label: 'Applications',
    title: 'Corporate Asset Structuring',
    items: [
      {
        title: 'Headquarters Acquisition',
        description: 'Technical structuring for commercial property acquisition via consortium, with cash flow impact analysis and tax planning.',
        icon: 'building'
      },
      {
        title: 'Expansion and New Locations',
        description: 'Modeling for opening branches, commercial points or operational units with working capital preservation and financial governance.',
        icon: 'store'
      },
      {
        title: 'Operational Asset Acquisition',
        description: 'Structuring for acquisition of vehicles, machinery, equipment and other productive assets with return on investment analysis.',
        icon: 'truck'
      }
    ]
  },
  when: {
    label: 'When It Makes Sense',
    title: 'Corporate Application Scenarios',
    scenarios: [
      {
        title: 'Working Capital Preservation',
        description: 'When the company needs to acquire assets without compromising operational liquidity or investment capacity in other strategic fronts.',
        points: [
          'Healthy cash flow but capital committed to operations',
          'Need to preserve credit lines for other purposes',
          'Simultaneous expansion planning on multiple fronts'
        ]
      },
      {
        title: 'Tax Planning',
        description: 'When structuring via consortium offers tax or accounting advantages compared to traditional financing.',
        points: [
          'Analysis of impact on balance sheet',
          'Comparison of effective costs versus bank credit',
          'Payment flow structuring aligned with tax regime'
        ]
      },
      {
        title: 'Governance and Discipline',
        description: 'When the company seeks acquisition structure with clear rules, cost predictability and absence of exchange rate variation.',
        points: [
          'Need for medium-term budget predictability',
          'Preference for regulated and transparent structures',
          'Alignment with internal corporate governance policies'
        ]
      },
      {
        title: 'Structured Expansion',
        description: 'When company growth demands acquisition of multiple assets with integrated financial planning.',
        points: [
          'Expansion plan with multiple scheduled acquisitions',
          'Need to structure staggered investment flow',
          'Coordination between different growth fronts'
        ]
      }
    ]
  },
  method: {
    label: 'FGT Method',
    title: 'How We Structure for Companies',
    description: 'Application of FGT method adapted to corporate context, with balance sheet impact analysis, cash flow and tax planning.',
    steps: [
      {
        title: 'Corporate Assessment',
        description: 'Analysis of company\'s wealth structure, acquisition objectives, payment capacity and impact on operational cash flow.'
      },
      {
        title: 'Feasibility Analysis',
        description: 'Scenario modeling comparing consortium versus credit alternatives, considering total costs, tax and accounting impacts.'
      },
      {
        title: 'Operation Structuring',
        description: 'Definition of legal structure, analysis of available regulations, administrator selection and payment flow planning.'
      },
      {
        title: 'Execution and Monitoring',
        description: 'Management of membership process, group monitoring until award or letter acquisition, and support in credit utilization.'
      }
    ]
  },
  governance: {
    label: 'Governance',
    title: 'Clarity and Technical Limits',
    points: [
      'Award depends on draw or bid, according to regulations. There is no timeline guarantee.',
      'Total costs vary according to group, administrator and specific regulation conditions.',
      'Technical analysis considers known variables but does not eliminate risks inherent to the consortium system.',
      'All operations are subject to registration and documentary approval by the chosen administrator.'
    ]
  },
  cta: {
    title: 'Structure Your Company\'s Assets',
    subtitle: 'Schedule a strategic assessment for technical feasibility analysis and acquisition structuring via consortiums.',
    button_primary: 'Request Corporate Assessment',
    button_secondary: 'WhatsApp'
  }
};
